import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { legalEndpoints } from '@/modules/legal/constants';
import { legalQueryKeys } from '@/modules/legal/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

export const useAcceptTermsMutation = () => {
  return useMutation({
    mutationFn: async (tenantId: string) => {
      await fetchClient.POST(legalEndpoints.termsAcceptance, {
        params: { query: { tenantId } },
      });
    },
    onSuccess: (_result, tenantId) =>
      invalidateQuery(legalQueryKeys.termsAcceptance(tenantId))(),
  });
};
